import React, { useEffect, useRef } from 'react';
import AudioPlayer from './AudioPlayer';

interface SongPlayerProps {
  videoId: string;
  roomId: string;
  isPreview?: boolean;
  preloaded?: boolean;
  /** Server timestamp of the round start; lets a late (re)joiner start mid-clip in sync. */
  roundStartTime?: number;
}

const SongPlayer: React.FC<SongPlayerProps> = ({ videoId, roomId, isPreview = false, preloaded = false, roundStartTime }) => {
  const playerRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    console.log(`SongPlayer mounted/updated with videoId: ${videoId}, preloaded: ${preloaded}`);
    
    if (isPreview) {
      // Load the YouTube IFrame API
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    }

    // Store the current ref value
    const currentPlayerRef = playerRef.current;

    // Clean up
    return () => {
      console.log(`SongPlayer unmounting for videoId: ${videoId}`);
      // Stop the player if it exists
      if (currentPlayerRef) {
        currentPlayerRef.src = '';
      }
    };
  }, [isPreview, videoId, preloaded]);

  // For preview, use YouTube iframe, for gameplay use AudioPlayer
  if (isPreview) {
    return (
      <div className="song-player">
        <iframe
          ref={playerRef}
          width="100%"
          height="315"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&disablekb=1&fs=0&modestbranding=1&rel=0`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    );
  } else {
    console.log(`Rendering AudioPlayer for videoId: ${videoId}, preloaded: ${preloaded}`);
    return (
      <div className="song-player">
        <AudioPlayer roomId={roomId} videoId={videoId} preloaded={preloaded} roundStartTime={roundStartTime} />
      </div>
    );
  }
};

export default SongPlayer;